import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/contexts/use-auth'

/**
 * Route guard auth-required képernyőkre (DEC-FE-006 / DEC-FE-013).
 * Az admin-flow ugyanazt a mintát követi, mint a publik FE — csak az
 * `/auth/login` cél a login-redirect (admin app-szintű, nem publik).
 */
export function RequireAuth() {
  const { authUser, isInitializing } = useAuth()
  const { t } = useTranslation()
  const location = useLocation()

  if (isInitializing) {
    return (
      <main
        className="min-h-screen bg-background text-foreground flex items-center justify-center p-4"
        aria-busy="true"
      >
        <p className="text-muted-foreground">{t('common.loading')}</p>
      </main>
    )
  }

  if (!authUser) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
